<template>
  <div class="card mb-5 mb-xxl-8">
    <!--begin::Body-->
    <div class="card mb-5 mb-xl-10" id="kt_profile_details_view">
      <!--begin::Card header-->
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label">{{ $t('shop.product_entry_unconform') }}</h3>
        </div>
        <div class="card-toolbar">
          
        </div>
      </div>
      <div class="card-body">
        <!--begin::Layout-->
        <div class="row">
          <!--begin::Table-->
          <table class="table align-middle table-row-bordered fs-6 gy-3 "  id="kt_datatable_shop_unconform_entries">
            <thead>
            <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
              <th class="min-w-100px">{{ $t('store.entrie.numero')}}</th>
              <th class="min-w-100px">{{ $t('shop.date')}}</th>
              <th class="min-w-100px">{{ $t('shop.store')}}</th>
              <th class="min-w-100px">{{ $t('shop.user_validate_entry')}}</th>
              <th class="min-w-100px">{{ $t('shop.entry_type')}}</th>
              <th class="min-w-100px">{{ $t('action') }}</th>
            </tr>
            </thead>

          </table>
          <!--end::Table-->
        </div>
        <!--end::Layout-->
      </div>

      <!--end::Card body-->
    </div>
    <!--end::Body-->
    <div class="modal fade" id="detailsEntryModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
      <div class="modal-dialog">
          <div class="modal-content" style="width: 700px;">
            <div class="modal-header">
              <h5 class="modal-title">{{ i18n.global.t('shop.shop_details_entry') }} {{ entryInfo.numero }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-2x"> X </span>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span > {{$t('shop.designation')}} </span>
                  </label>
                </div>
                <div class="col-md-2">
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span> {{$t('shop.status')}}</span>
                  </label>
                </div>
                <div class="col-md-2">
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span> {{$t('shop.quantity')}}</span>
                  </label>
                </div>
                <div class="col-md-2">
                  <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span> {{$t('shop.received_quantity')}}</span>
                  </label>
                </div>
              </div>
              <div class="row" v-for="entry in entryInfo.productSaleElements.slice(0, 10)" :key="entry.name">
                <div class="col-md-6">
                  <input type="text" readonly class="form-control form-control-solid" v-model="entry.name" />
                </div>
                <div class="col-md-2">
                  <span style="color: green; margin-top: 10%; font-size: 15px;" v-show="entry.status == 'conform'"> {{$t('shop.shop_conform')}} </span>
                  <span style="color: red; margin-top: 10%; font-size: 15px;" v-show="entry.status == 'unconform'"> {{$t('shop.shop_unconform')}} </span>
                </div>
                <div class="col-md-2">
                  <input type="number" readonly class="form-control form-control-solid" v-model="entry.product_quantity" />
                </div>
                <div class="col-md-2" >
                  <input type="number" readonly class="form-control form-control-solid" v-model="entry.received_quantity" />
                </div>
                <hr class="mt-5">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal"> {{ $t('button.close') }} </button>
            </div>
          </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" id="kt_modal_2">
      <div class="modal-dialog modal-lg">
          <div class="modal-content shadow-none">
              <div class="modal-header">
                  <h5 class="modal-title">{{ i18n.global.t('shop.shop_details_entry') }} {{ entryInfo.numero }}</h5>

                  <!--begin::Close-->
                  <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                      <span class="svg-icon svg-icon-2x">x</span>
                  </div>
                  <!--end::Close-->
              </div>

              <div v-show="isDisponible" class="modal-body">
                <div class="row">
                  <div class="col-md-6">
                    <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                      <span > {{$t('shop.designation')}} </span>
                    </label>
                  </div>
                  <div class="col-md-2">
                    <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                      <span> {{$t('shop.status')}}</span>
                    </label>
                  </div>
                  <div class="col-md-2">
                    <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                      <span> {{$t('shop.quantity')}}</span>
                    </label>
                  </div>
                  <div class="col-md-2">
                    <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                      <span> {{$t('shop.received_quantity')}}</span>
                    </label>
                  </div>
                </div>
                <div class="row" v-for="entry in entryInfo.productSaleElements.slice(0, 10)" :key="entry.name">
                  <div class="col-md-6">
                    <input type="text" readonly class="form-control form-control-solid" v-model="entry.name" />
                  </div>
                  <div class="col-md-2">
                    <span style="color: green; margin-top: 10%; font-size: 15px;" v-show="entry.status == 'conform'"> {{$t('shop.shop_conform')}} </span>
                    <span style="color: red; margin-top: 10%; font-size: 15px;" v-show="entry.status == 'unconform'"> {{$t('shop.shop_unconform')}} </span>
                  </div>
                  <div class="col-md-2">
                    <input type="number" readonly class="form-control form-control-solid" v-model="entry.product_quantity" />
                  </div>
                  <div class="col-md-2" >
                    <input type="number" readonly class="form-control form-control-solid" v-model="entry.received_quantity" />
                  </div>
                  <hr class="mt-5">
                </div>
              </div>
              <div class="modal-body loader" v-show="!isDisponible">
                <Loader text="Loading..." />
              </div>

              <div class="modal-footer">
                  <button type="button" class="btn btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
              </div>
          </div>
      </div>
  </div>
  </div>
</template>

<script>
import {BASE_URL} from "@/services/api";
import {mapActions} from "vuex";
import Loader from "@/components/Loader.vue";

export default {
  name: "Entry",
  components: { Loader },
  data(){
    return{
      entryInfo: {
        productSaleElements : [],
      }
    }
  },

  async mounted() {
    $('body .pre').css('display', 'block')
      this.fetchDatas()
   
      $(document).on("click", "#kt_datatable_shop_unconform_entries .view_btn", async(e) => {
      let id_entry = e.target.getAttribute('data-id')
      if(id_entry){
        await this.detailProductBonModalOpen(id_entry)
      }
    });
    $('body .pre').css('display', 'none')
  },

  watch: {
    '$route.params.id'(newId, oldId) {
      // Vue Router réutilise ce composant quand on passe de la fiche d'une
      // boutique à une autre (même route, seul :id change) — sans ce watcher,
      // la datatable garde les entrées non conformes de l'ancienne boutique.
      if (newId && newId !== oldId) this.fetchDatas()
    },
  },

  methods: {
    ...mapActions('shop', [
      'showShop',
      'showShopEntryProduct'
    ]),
    async detailProductBonModalOpen(entry_id){
      this.isDisponible = false
      let response = await this.showShopEntryProduct({shop_id: this.$route.params.id, entry_id: entry_id})
      this.entryInfo = response.data.entry_shop
      this.entryInfo.productSaleElements = response.data.productSaleElements_collection
      this.isDisponible = true
    },
    fetchDatas() {
      const AUTH_TOKEN = Ls.get('auth.token')

      this.table = $("#kt_datatable_shop_unconform_entries").DataTable({
        destroy: true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength: Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100],
        order: [[0, 'desc']],
        ajax: {
          url: BASE_URL + '/get/shop/' + this.$route.params.id + '/unconform/entries/datatables',
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },
          data: function (d) {

          }
        },
        columns: [{data: "numero"}, {data: "date"},  {data: "store"}, {data: "user"}, {data: "type"}, {data: "Actions", responsivePriority: -1}],

        columnDefs: [
          {
            targets: -6,
            order: "desc",
            className: "dt-center clickable",
            render: function (t, a, e, l) {
              return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -5,
            order: "desc",
            className: "dt-center clickable",
            render: function (t, a, e, l) {
              return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -4,
            order: "desc",
            className: "dt-center clickable",
            render: function (t, a, e, l) {
              return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -3,
            order: "desc",
            className: "dt-center clickable",
            render: function (t, a, e, l) {
              return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -2,
            order: "desc",
            className: "dt-center clickable",
            render: function (t, a, e, l) {
              let render = ""

              if(e.type == "entry"){
                render+='<span data-id="' + e.id + '"  class="badge badge-light-success typeRow' + l.row + '"> Entrée validée </span>'
              }
              
              return render
            },
          },
          {
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              let render = ""
              if(this.$can('no_conform_entry_boutique_view')  ){
                render+='<button type="button" data-bs-toggle="modal" data-bs-target="#kt_modal_2" data-row="'+ l.row +'" data-id="'+ e.id +'" class="btn btn-icon btn-active-light-primary w-30px h-30px ms-auto view_btn">' +
                    '<i data-row="'+ l.row +'" data-id="'+ e.id +'"   class="fa fa-eye"></i>' +
                    '</button> '
              }


              return render
            },
          }
        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json",
        }
      });
    },
  }
}
</script>

<style scoped>
    .badge {
        display: none !important;
        align-items: center;
    }
    .badge-light-danger {
        color: #f1416c;
        background-color: #fff5f8;
        padding: 15px !important;
        text-align: center !important;
    }
    .loader {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 30vh;
  background-color: #f8f8f8;
}
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

@keyframes blink {
  50% {
    border-color: transparent;
  }
}
</style>
